import { render, staticRenderFns } from "./yellowLodaing.vue?vue&type=template&id=2c5b8c8a"
import script from "./yellowLodaing.vue?vue&type=script&lang=js"
export * from "./yellowLodaing.vue?vue&type=script&lang=js"
import style0 from "./yellowLodaing.vue?vue&type=style&index=0&id=2c5b8c8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports